import React from "react";

import entrepreneurImage from "../../assets/images/Entrepreneur.png";
import smallBusinessOwnerImage from "../../assets/images/Owner.png";
import bloggerImage from "../../assets/images/Producer.png";
import freelancerImage from "../../assets/images/Freelancer.png";
import testerImage from "../../assets/images/Tester.png";
import sovereignImage from "../../assets/images/Sovereign.png";

function BenefitsSection() {
  const benefitCards = [
    {
      title: "Entrepreneurs with large businesses",
      image: entrepreneurImage,
      description:
        "Provides instant response to inquiries across all messaging platforms and websites. Engages with potential clients 24/7, guaranteed to boost business revenue.",
      roles:
        "Sales Manager, Technical Support Specialist, Consultant, and more.",
    },
    {
      title: "Small business owners, both offline and online",
      image: smallBusinessOwnerImage,
      description:
        "The AI employee is more affordable and reliable, especially during early growth. No inquiries will go unanswered, ensuring quality and fast response.",
      roles: "Consultant, Administrator, Expert, Assistant, and more.",
    },
    {
      title: "Bloggers, experts, producers",
      image: bloggerImage,
      description:
        "The AI employee can handle audience communication. Freeing you and your team from sending out newsletters and from direct communication with potential clients during high-demand periods.",
      roles:
        "Mentor, Expert, Customer Care Specialist, Curator, Project Manager, and more.",
    },
    {
      title: "Freelancers",
      image: freelancerImage,
      description:
        "The AI employee can manage: client briefings, attract new inquiries, collect necessary information, analyze data, and more.",
      roles:
        "Sales Assistant, Personal Assistant, Project Manager, Copywriter, and more.",
    },
    {
      title: "Tester for applications, products",
      image: testerImage,
      description:
        "This AI automates product and application testing to find bugs, performance issues, and usability flaws, ensuring quality and freeing up your team to focus on development.",
      roles: "QA Automation Engineer, Performance Tester, Security Analyst.",
    },
    {
      title: "Sovereign for critical services",
      image: sovereignImage,
      description:
        "The Sovereign AI autonomously manages critical business operations. By analyzing data and making strategic decisions, it optimizes performance and ensures compliance.",
      roles: "vCOO, Strategic Analyst, Operations Lead.",
    },
  ];

  return (
    <section className="bg-slate-50 py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-slate-800 mb-4">
          <span className="text-cyan-500">Who</span> can benefit{" "}
          <br className="sm:hidden" />
          from an AI employee?
        </h2>
        <p className="text-lg text-slate-600 mb-12 hidden sm:block">
          AI employees are versatile and can enhance productivity across various
          business types.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {benefitCards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden flex flex-col hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              {/* Image and Title Header */}
              <div className="bg-slate-800 p-6 flex items-center space-x-4">
                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-cyan-400 flex-shrink-0">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-bold text-white text-left">
                  {card.title}
                </h3>
              </div>

              {/* Card Body */}
              <div className="p-6 text-left flex-grow flex flex-col justify-between">
                <div>
                  <p className="text-slate-700 mb-4 flex-grow">
                    {card.description}
                  </p>
                </div>
                {/* Possible AI Employee Roles */}
                <div className="mt-4 pt-4 border-t border-slate-100">
                  <p className="text-sm font-semibold text-slate-800 mb-2">
                    Possible AI employee roles:
                  </p>
                  <p className="text-sm text-cyan-600 font-medium">
                    {card.roles}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BenefitsSection;

